mod.modules.define("CompanySection", "BaseSection", function(fn) {
	"use strict";

	fn.prototype.init = function(params) {
		this.base("init", params);

		this.initTemplateModals();
	};

	// Attach modals to the body so z-indexing works and bind events
	fn.prototype.initTemplateModals = function () {
		var modals = this.el.find("div.template-modal");

		modals.find("input").defaultValue();

		$("button[data-toggle!=modal]", modals).on("click", function(e) {
			mod.observer.trigger("template - modal button clicked", $(this));
		});

		$("#template-save-modal").on("show.bs.modal", function (e) {
			mod.observer.trigger("template - save modal show", $(this));
		});

		modals.detach().appendTo($("body"));
	};

	fn.prototype.observables = {
		"symbol - changed": function (context) {
			$("div.template-modal").remove();

			this.reloadQueue({
				Symbol: context.symbol,
				ListId: context.listId
			});
		}
	};

});